export const SET_APP_SNACKBAR = 'SET_APP_SNACKBAR';
export const SET_APP_TOAST = 'SET_APP_TOAST';

export const SET_ARTICLE = 'SET_ARTICLE';
export const SET_ARTICLE_EDITING = 'SET_ARTICLE_EDITING';
export const SET_ARTICLE_EDITING_FIELD = 'SET_ARTICLE_EDITING_FIELD';
export const SET_ARTICLE_EDITING_TAG_AT_INDEX = 'SET_ARTICLE_EDITING_TAG_AT_INDEX';
export const SET_ARTICLE_FIELD = 'SET_ARTICLE_FIELD';
export const SET_ARTICLES = 'SET_ARTICLES';
export const UNSET_ARTICLE = 'UNSET_ARTICLE';

export const INSERT_BELIEF_STATEMENT = 'INSERT_BELIEF_STATEMENT';
export const SET_BELIEF_STATEMENT = 'SET_BELIEF_STATEMENT';
export const SET_BELIEF_STATEMENT_FIELD = 'SET_BELIEF_STATEMENT_FIELD';
export const SET_BELIEF_STATEMENTS = 'SET_BELIEF_STATEMENTS';
export const UNSET_BELIEF_STATEMENT = 'UNSET_BELIEF_STATEMENT';

export const SET_LOGIN = 'SET_LOGIN';
export const SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS';
export const SET_LOGIN_FAILURE = 'SET_LOGIN_FAILURE';
export const SET_LOGOUT = 'SET_LOGOUT';
export const SET_AUTH_PAYLOAD = 'SET_AUTH_PAYLOAD';

export const ADD_TO_GALLERY_FOR_ACCOUNT = 'ADD_TO_GALLERY_FOR_ACCOUNT';
export const REMOVE_FROM_GALLERY_FOR_ACCOUNT = 'REMOVE_FROM_GALLERY_FOR_ACCOUNT';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_ACCOUNT_FIELD = 'SET_ACCOUNT_FIELD';
export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SORT_GALLERY_FOR_ACCOUNT = 'SORT_GALLERY_FOR_ACCOUNT';

export const SET_CHANNEL = 'SET_CHANNEL';
export const SET_CHANNEL_FIELD = 'SET_CHANNEL_FIELD';
export const SET_CHANNELS = 'SET_CHANNELS';
export const UNSET_CHANNEL = 'UNSET_CHANNEL';

export const SET_COLLECTION = 'SET_COLLECTION';
export const SET_COLLECTION_FIELD = 'SET_COLLECTION_FIELD';
export const SET_COLLECTION_FILTER_FIELD = 'SET_COLLECTION_FILTER_FIELD';
export const SET_COLLECTIONS = 'SET_COLLECTIONS';
export const UNSET_COLLECTION = 'UNSET_COLLECTION';

export const SET_EPISODE = 'SET_EPISODE';
export const SET_EPISODE_FIELD = 'SET_EPISODE_FIELD';
export const SET_EPISODE_FILTER_FIELD = 'SET_EPISODE_FILTER_FIELD';
export const SET_EPISODE_TAG_AT_INDEX = 'SET_EPISODE_TAG_AT_INDEX';
export const SET_EPISODE_COLLECTION_AT_INDEX = 'SET_EPISODE_COLLECTION_AT_INDEX';
export const SET_EPISODES = 'SET_EPISODES';
export const UNSET_EPISODE = 'UNSET_EPISODE';
export const UPDATE_EPISODE_FIELD = 'UPDATE_EPISODE_FIELD';

export const ADD_PACKAGE_FOR_EVENT = 'ADD_PACKAGE_FOR_EVENT';
export const REMOVE_PACKAGE_FOR_EVENT = 'REMOVE_PACKAGE_FOR_EVENT';
export const SET_EVENT = 'SET_EVENT';
export const SET_EVENT_FIELD = 'SET_EVENT_FIELD';
export const SET_EVENTS = 'SET_EVENTS';
export const SET_EVENTS_REFRESH = 'SET_EVENTS_REFRESH';
export const SET_PACKAGE_FIELD_FOR_EVENT = 'SET_PACKAGE_FIELD_FOR_EVENT';
export const TOGGLE_EVENTS_TAG = 'TOGGLE_EVENTS_TAG';
export const UNSET_EVENT = 'UNSET_EVENT';

export const SET_EVENT_CONTACT = 'SET_EVENT_CONTACT';
export const SET_EVENT_CONTACT_FIELD = 'SET_EVENT_CONTACT_FIELD';
export const SET_EVENT_FILTER_FIELD = 'SET_EVENT_FILTER_FIELD';
export const SET_EVENT_PACKAGE = 'SET_EVENT_PACKAGE';

export const SET_EVENT_REGISTRATION = 'SET_EVENT_REGISTRATION';
export const SET_EVENT_REGISTRATION_REFRESH = 'SET_EVENT_REGISTRATION_REFRESH';
export const SET_EVENT_REGISTRATIONS = 'SET_EVENT_REGISTRATIONS';

export const SET_EVENT_ORDERS = 'SET_EVENT_ORDERS';

export const ADD_FORM_BLOCK_AT_INDEX = 'ADD_FORM_BLOCK_AT_INDEX';
export const ADD_FORM_FIELD_FOR_BLOCK = 'ADD_FORM_FIELD_FOR_BLOCK';
export const MOVE_FORM_FIELD_FOR_BLOCK = 'MOVE_FORM_FIELD_FOR_BLOCK';
export const REMOVE_BLOCK_FROM_FORM = 'REMOVE_BLOCK_FROM_FORM';
export const REMOVE_FORM_FIELD_FOR_BLOCK = 'REMOVE_FORM_FIELD_FOR_BLOCK';
export const SET_FORM = 'SET_FORM';
export const SET_FIELD_FOR_BLOCK = 'SET_FIELD_FOR_BLOCK';
export const SET_FIELD_FOR_BLOCK_FIELD = 'SET_FIELD_FOR_BLOCK_FIELD';
export const SET_FORM_SAVING = 'SET_FORM_SAVING';
export const SET_FORM_REFRESH = 'SET_FORM_REFRESH';

export const SET_FORM_FIELD = 'SET_FORM_FIELD';
export const SET_FORM_FIELD_FIELD = 'SET_FORM_FIELD_FIELD';

export const SET_LOCATION = 'SET_LOCATION';
export const SET_LOCATIONS = 'SET_LOCATIONS';

export const SET_MEDIA = 'SET_MEDIA';
export const SET_MEDIA_FILTER_FIELD = 'SET_MEDIA_FILTER_FIELD';
export const SET_MEDIA_FILTER_DEFAULT_DATES = 'SET_MEDIA_FILTER_DEFAULT_DATES';
export const SET_MEDIA_REFRESH = 'SET_MEDIA_REFRESH';
export const SET_MEDIA_TAB = 'SET_MEDIA_TAB';
export const TOGGLE_MEDIA_TAG = 'TOGGLE_MEDIA_TAG';

export const SET_MEMBER = 'SET_MEMBER';
export const SET_MEMBER_FIELD = 'SET_MEMBER_FIELD';
export const SET_MEMBERS = 'SET_MEMBERS';
export const UNSET_MEMBER = 'UNSET_MEMBER';

export const ADD_TO_GALLERY_FOR_MINISTRY = 'ADD_TO_GALLERY_FOR_MINISTRY';
export const ADD_ROLE_FOR_MINISTRY = 'ADD_ROLE_FOR_MINISTRY';
export const ADD_SERVICE_FOR_MINISTRY = 'ADD_SERVICE_FOR_MINISTRY';
export const INSERT_MINISTRY = 'INSERT_MINISTRY';
export const INSERT_ROLE_FOR_MINISTRY = 'INSERT_ROLE_FOR_MINISTRY';
export const REMOVE_FROM_GALLERY_FOR_MINISTRY = 'REMOVE_FROM_GALLERY_FOR_MINISTRY';
export const REMOVE_SERVICE_FOR_MINISTRY = 'REMOVE_SERVICE_FOR_MINISTRY';
export const REMOVE_ROLE_FOR_MINISTRY = 'REMOVE_ROLE_FOR_MINISTRY';
export const SET_FIELD_FOR_ROLE_FOR_MINISTRY = 'SET_FIELD_FOR_ROLE_FOR_MINISTRY';
export const SET_FIELD_FOR_SERVICE_FOR_MINISTRY = 'SET_FIELD_FOR_SERVICE_FOR_MINISTRY';
export const SET_MINISTRY = 'SET_MINISTRY';
export const SET_MINISTRY_MODE = 'SET_MINISTRY_MODE';
export const SET_MINISTRY_REFRESH = 'SET_MINISTRY_REFRESH';
export const SET_MINISTRY_FIELD = 'SET_MINISTRY_FIELD';
export const SET_MINISTRY_FILTER_FIELD = 'SET_MINISTRY_FILTER_FIELD';
export const SET_MINISTRIES = 'SET_MINISTRIES';
export const SORT_GALLERY_FOR_MINISTRY = 'SORT_GALLERY_FOR_MINISTRY';
export const UNSET_MINISTRY = 'UNSET_MINISTRY';

export const SET_MINISTRY_ROLE = 'SET_MINISTRY_ROLE';

export const SET_ORDER = 'SET_ORDER';

export const SET_PAGE_LIST = 'SET_PAGE_LIST';
export const SET_PAGE = 'SET_PAGE';
export const SET_PAGE_FIELD = 'SET_PAGE_FIELD';

export const SET_USER = 'SET_USER';
export const SET_USER_FIELD = 'SET_USER_FIELD';
export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER';
export const SET_USERS = 'SET_USERS';
export const SET_USERS_REFRESH = 'SET_USERS_REFRESH';
export const UNSET_USER = 'UNSET_USER';
export const UNSET_AUTHENTICATED_USER = 'UNSET_AUTHENTICATED_USER';

export const INSERT_SERVICE = 'INSERT_SERVICE';
export const SET_SERVICE = 'SET_SERVICE';
export const SET_SERVICE_FIELD = 'SET_SERVICE_FIELD';
export const SET_SERVICES = 'SET_SERVICES';
export const UNSET_SERVICE = 'UNSET_SERVICE';

export const INSERT_STAFF_MEMBER = 'INSERT_STAFF_MEMBER';
export const SET_STAFF_MEMBER = 'SET_STAFF_MEMBER';
export const SET_STAFF_MEMBER_FIELD = 'SET_STAFF_MEMBER_FIELD';
export const SET_STAFF_MEMBERS = 'SET_STAFF_MEMBERS';
export const UNSET_STAFF_MEMBER = 'UNSET_STAFF_MEMBER';

export const SET_SPEAKER = 'SET_SPEAKER';
export const SET_SPEAKER_FIELD = 'SET_SPEAKER_FIELD';
export const SET_SPEAKER_FILTER_FIELD = 'SET_SPEAKER_FILTER_FIELD';
export const SET_SPEAKERS = 'SET_SPEAKERS';
export const UNSET_SPEAKER = 'UNSET_SPEAKER';

export const SET_TAG = 'SET_TAG';

export const SET_WAIVER = 'SET_WAIVER';
export const SET_WAIVER_FIELD = 'SET_WAIVER_FIELD';
export const SET_WAIVERS = 'SET_WAIVERS';
export const UNSET_WAIVER = 'UNSET_WAIVER';



// WEBPACK FOOTER //
// ./src/store/types/mutations.js